import * as actionTypes from './actionType';

const initialState = {
    firstName: '',
    lastName: '',
    countriesName: [],
    statesName: [],
    addresses: [],
    address: '',
    selectedCountry: '',
    country_id: 0,
    selectedState: '',
    state_id: 0,
    city: '',
    zipCode: '',
    phoneNumber: '',
    faxNumber: '',
    delivery_id: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.NEW_PATIENT_DELIVERY_FIRST_NAME:
            return {
                ...state,
                firstName: action.value,
            };
        case actionTypes.NEW_PATIENT_DELIVERY_LAST_NAME:
            return {
                ...state,
                lastName: action.value,
            };
        case actionTypes.NEW_PATIENT_DELIVERY_ADDRESS_ID:
            return {
                ...state,
                delivery_id: action.value,
                addresses: [
                    ...state.addresses,
                    {
                        delivery_address_id: action.value,
                        first_name: state.firstName,
                        last_name: state.lastName,
                        address_1: state.address,
                        city: state.city,
                        country_id: state.country_id,
                        state_province_id: state.state_id,
                        postcode: state.zipCode,
                        phone_no: state.phoneNumber,
                        fax_no: state.faxNumber,
                    },
                ],
            };
        case actionTypes.NEW_PATIENT_DELIVERY_ADDRESS:
            const isAddressListValid = Array.isArray(action.address) && action.address.length > 0;
            // set default address data
            let addressData = {
                address: isAddressListValid ? action.address[0].address_1 : '',
                city: isAddressListValid ? action.address[0].city : '',
                zipCode: isAddressListValid ? action.address[0].postcode : '',
                phoneNumber: isAddressListValid ? action.address[0].phone_no : '',
                delivery_id: isAddressListValid ? action.address[0].delivery_address_id : 'New Address',
            };
            // check if delivery_id is not null and not 'New Address'
            // if true, find the address from the list of addresses and set the address data
            if (action.delivery_id && action.delivery_id !== 'New Address') {
                const matchAddress = state.addresses.find((a) => a.delivery_address_id === action.delivery_id);
                if (matchAddress) {
                    addressData = {
                        address: matchAddress.address_1,
                        city: matchAddress.city,
                        zipCode: matchAddress.postcode,
                        phoneNumber: matchAddress.phone_no,
                        delivery_id: matchAddress.delivery_address_id,
                    };
                }
            }
            return {
                ...state,
                address: addressData.address,
                city: addressData.city,
                zipCode: addressData.zipCode,
                phoneNumber: addressData.phoneNumber,
                delivery_id: addressData.delivery_id,
            };
        case actionTypes.NEW_PATIENT_DELIVERY_ADDRESS_INIT:
            return {
                ...state,
                countriesName: action.country,
                selectedCountry: action.country[0].country_id,
                country_id: action.country[0].country_id,
                statesName: action.state,
                selectedState: action.state[0].state_province_id,
                state_id: action.state[0].state_province_id,
                addresses: action.address,

                city: action.address.length > 0 ? action.address[0].city : '',
                zipCode: action.address.length > 0 ? action.address[0].postcode : '',
                phoneNumber: action.address.length > 0 ? action.address[0].phone_no : '',
                faxNumber: action.address.length > 0 ? action.address[0].fax_no : '',

                address: action.address.length > 0 ? action.address[0].address_1 : '',
                delivery_id: action.address.length > 0 ? action.address[0].delivery_address_id : 'New Address',
            };
        case actionTypes.NEW_PATIENT_DELIVERY_ADDRESS_LINE:
            return { ...state, address: action.value };

        case actionTypes.NEW_PATIENT_DELIVERY_ADDRESS_COUNTRY:
            const counrtyId = action.value;
            const firstMatchState = state.statesName.find((s) => s.country_id === counrtyId);
            let stateValue = firstMatchState ? firstMatchState.state_province_id : null;
            return {
                ...state,
                selectedCountry: action.value,
                country_id: action.value,
                selectedState: stateValue,
                state_id: stateValue,
            };

        case actionTypes.NEW_PATIENT_DELIVERY_ADDRESS_STATE:
            return {
                ...state,
                selectedState: action.value,
                state_id: action.value,
            };
        case actionTypes.NEW_PATIENT_DELIVERY_ADDRESS_CITY:
            return {
                ...state,
                city: action.value,
            };
        case actionTypes.NEW_PATIENT_DELIVERY_ADDRESS_ZIPCODE:
            return {
                ...state,
                zipCode: action.value,
            };
        case actionTypes.NEW_PATIENT_DELIVERY_ADDRESS_PHONE:
            return {
                ...state,
                phoneNumber: action.value,
            };
        case actionTypes.NEW_PATIENT_DELIVERY_ADDRESS_FAX:
            return {
                ...state,
                faxNumber: action.value,
            };
    }
    return state;
};

export default reducer;
